<template>
    <div class="ikz-bg-filter" v-show="dialogVisible.status" id="ikz-sys-map" style="z-index: 2001 !important;">

        <div class="ikz-sys-pic-section" v-show="dialogVisible.status">
            <div class="ikz-pic-box">
                <div class="ikz-top-menu ikz-pic-group">
                    <button type="button" :style="menu_left" class="ikz-top-menu-left" @click="menuLeft">个人图库</button>
                    <!-- <button type="button" :style="menu_right" class="ikz-top-menu-right" @click="menuRight">其他资源</button> -->
                    <!-- <button type="button" :style="menu_other" class="ikz-top-menu-right" @click="menuOther">其他资源</button> -->
                </div>
                <el-button type="primary" size="mini" class="ikz-pic-updata"  @click="dialogVisibleUpload=true">新增图片
                    <!-- <input type="file" style="width:80px;height:28px;" id="upload_ele" multiple="false" accept="image/*" @input="ikzSysPicPreviewImage" class="ikz-pic-file-input" /> -->
                </el-button>
                <div class="ikz-pic-list">
                    <div class="ikz-pic-list-left">
                        <el-tabs class="ikz-pic-list-left-tabs" v-model="activeName" tab-position="left" @tab-click="ikzSysPicTypeid">
                            <el-tab-pane  v-for="(item,index) in  picstype" :key="index" :label="item.bname"></el-tab-pane>
                            <el-tab-pane v-if="ikz_sys_pic_info.change == 'per'" name="-1" label="添加分组"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="ikz-pic-list-right">
                        <div class="ikz-pic-list-right-tips" v-show="ikz_sys_pic_info.change == 'sys'&&ikz_sys_pic_info.id!=0">
                            <el-button type="text" v-for="(item,index) in ikz_sys_pic_second" :key="index" class="ikz-sys-pic-tids" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" :style="item.color" @click="secondSelect(item.id)">{{ item.bname }}</el-button>
                        </div>
                        <div class="ikz-pic-right-image">
                            <div v-show="null_status" class="ikz-null">
                                <img class="ikz-null-img" :src="nullurl" />
                                <div class="ikz-null-title">
                                    该分类下暂无图片~
                                </div>
                            </div>
                            <div class="ikz-sys-pic-picsbod" v-for="(item,index) in  ikz_sys_pic_data"  :key="index" @click="ikzSysPicGetImg(item.image,item.id,index)">
                                <div class='ikz-sys-pic-picssdiv' v-show="item.status">

                                    <i class="el-icon-circle-check ikz-sys-pic-picsselt" style="color:#409EFF;"></i>
                                </div>
                                <el-image  style="width: 70px; margin:5px;max-height: 70px;overflow: hidden;" :src="item.image"></el-image>
                                
                                <!-- <video v-else-if="item.pic_type == 3" style="width: 70px; margin:5px;max-height: 70px;overflow: hidden;" :src="item.image"></video> -->

                            </div>
                        </div>
                        <div class="ikz-sys-pic-bottom">
                            <el-pagination :page-size="ikz_sys_pic_info.limit" current-change="pagechange" layout="prev, pager, next" :current-page="ikz_sys_pic_info.page" @current-change="handleCurrentChange" :total="ikz_sys_pic_count">
                            </el-pagination>
                            <div slot="footer" class="ikz-sys-pic-btn" style="">
                                <el-button size="mini" @click="dialogVisible.status = false">取 消</el-button>
                                <el-button size="mini" type="primary" @click="ikzSysPicSubmit">确 定</el-button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
        <div class="ikz-add-type" v-show="dialogFormVisible">
            <div class="ikz-add-box">
                <div class="ikz-add-title">添加分组</div>
                <el-form :model="form" class="ikz-add-form" label-width="100px" ref="form">
                    <el-form-item label="分类名称">
                        <el-input v-model="form.bname" style="width:255px;" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="ikz-add-footer">
                    <el-button @click="ikzSysPicOpenClose()">取 消</el-button>
                    <el-button type="primary" @click="ikzSysPicOpenadd()">确 定</el-button>
                </div>
            </div>
        </div>
        <ele-pay :mode="pay_mode" :title="pay_title" :status.sync="pay_status"></ele-pay>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisibleUpload"
          width="400px"
          :before-close="handleClose"
          :modal="false">
          <el-upload
            class="upload-demo"
            drag
            :headers='Headers'
            :action="action"
            :multiple="false"
            :data="{tid:ikz_sys_pic_info.id}"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleUploadClose">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleUploadClose">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import ElePay from '@/components/ElePay'
    // import ikz from '../../common/tools'
    import Vue from 'vue'
    import axios from "axios";
    import store from '@/store'
    import setting from '@/config/setting'
    export default {
        name: 'GalleryShow',
        components: {
            ElePay
        },
        props: {
            infoData: [Object, String]
        },
        data() {
            return {
                action:setting.baseURL+'/storage/StoragePictures/uploadImage',
                Headers:{
                    authorization:store.state.user.token,
                },
                dialogVisibleUpload:false,
                pay_status:false,
                image_list: '',
                visible: false,
                nullurl: '',
                null_status: false,
                dialogFormVisible: false, //添加分组弹窗
                form: {
                    bname: '',
                },
                img: {
                    url: '',
                },
                formLabelWidth: '120px', //弹窗宽度
                menu_left: "background:#409EFF;color:#fff;border-color:#409EFF",
                menu_right: "background:#fff;color:#353535;border-color:#DCDFE6",
                menu_other: "background:#fff;color:#353535;border-color:#DCDFE6",
                activeName: '0',
                oldactiveName: '0',
                dialogVisible: {
                    status: false
                },//隐藏图库选择
                tabPosition: 'per',
                ikz_sys_pic_click_status: false,
                ikz_sys_pic_return: [], //选择后的图片容器
                ikz_sys_pic_data: [], //服务器图片信息接收容器
                ikz_sys_pic_count: 0, //服务器全部图片计数，用于分页显示
                ikz_sys_pic_info: {
                    'change': 'per',
                    'id': '0',
                    'limit': 18,
                    'page': 1,
                    'sid': '0',
                }, //服务器请求的参数打包
                ikz_sys_pic_receive: [], //调用接口传入的参数全局容器
                ikz_sys_pic_status: 3, //是否更新列表
                ikz_sys_pic_key: 3, //是否更新分页
                ikz_sys_pic_ajax_tid: 0, //上传图片的分类id
                ikz_sys_pic_load: '', //加载图
                picstype: [], //图库分类
                ikz_sys_pic_second: [], //二级
                show_status: 2, //初次进入
                pic_path: '', //图片服务器地址
                sys_status:false,
                pay_mode:'image',
                pay_title:'空间不足',
            }
        },
        watch: {
            infoData: {
                handler(newName) {
                    this.dialogVisible = newName;
                    if(newName.status) {
                        console.log(newName)
                        newName.num = newName.num || -1;
                        newName.strict = newName.strict || false;
                        // newName.former = newName.former || '';
                        newName.sys_status = newName.sys_status || false;
                        this.show_status = 2; //初次进入
                        this.ikz_sys_pic_receive = newName;
                        this.ikz_sys_pic_return = [];
                        this.ikz_sys_pic_status = 3;
                        this.ikz_sys_pic_key = 3;
                        this.ikzSysPicPictypelist();
                        this.ikzSysPicPictureLists();
                        this.sys_status = newName.sys_status;
                        if(!this.sys_status){
                            this.menu_left = "background:#409EFF;color:#fff;border-color:#409EFF;border-radius: 3px;";
                        }
                    }
                },
                immediate: true,
                deep: true
            },
            activeName: {
                handler(newName, oldName) {
                    this.oldactiveName = oldName;
                },
                immediate: true,
                deep: true
            }

        },
        methods: {
            dialogVisibleUploadClose(){
                this.ikzSysPicPictureLists();
                this.dialogVisibleUpload = false;
            },
            menuLeft() {

                this.tabPosition = 2;
                this.menu_left = "background:#409EFF;color:#fff;border-color:#409EFF";
                this.menu_other = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.menu_right = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.ikz_sys_pic_info.change = 'per';
                this.activeName = '0';
                this.ikz_sys_pic_info.id = "0";
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = "0";
                this.ikz_sys_pic_return = [];
                this.picstype = [];
                this.ikzSysPicPictureLists();
                this.ikzSysPicPictypelist();
            },
            menuRight() {
                this.tabPosition = 3;
                this.menu_left = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.menu_right = "background:#409EFF;color:#fff;border-color:#409EFF";
                this.menu_other = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.ikz_sys_pic_info.change = 'sys';
                this.activeName = '0';
                this.ikz_sys_pic_info.id = "0";
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = "0";
                this.ikz_sys_pic_return = [];
                this.picstype = [];
                this.ikzSysPicPictureLists();
                this.ikzSysPicPictypelist();
            },
            menuOther(){
                this.tabPosition = 3;
                this.menu_left = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.menu_right = "background:#fff;color:#353535;border-color:#DCDFE6";
                this.menu_other = "background:#409EFF;color:#fff;border-color:#409EFF";
                this.ikz_sys_pic_info.change = 'sys';
                this.activeName = '0';
                this.ikz_sys_pic_info.id = "0";
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = "0";
                this.ikz_sys_pic_return = [];
                this.picstype = [];
                this.ikzSysPicPictureLists();
                this.ikzSysPicPictypelist();
            },
            
            
            pagechange() {},

            //鼠标移入
            mouseOver(index) {
                var temp = this.ikz_sys_pic_second[index];
                temp.color = 'color:#409EFF';
                Vue.set(this.ikz_sys_pic_second, index, temp)

            },
            //鼠标移出

            mouseLeave(index) {

                var temp = this.ikz_sys_pic_second[index];
                temp.color = 'color:#303133;';
                Vue.set(this.ikz_sys_pic_second, index, temp)
            },

            /** 图库选择器封装开始 **/
            secondColor() {
                for(var j = 0; j< this.ikz_sys_pic_second.length; j++) {
                    this.ikz_sys_pic_second[j].color = '';
                }
                //				this.ikz_sys_pic_second[index].color = 'color:#409EFF';
                for(var i = 0; i < this.ikz_sys_pic_second.length; i++) {
                    if(this.ikz_sys_pic_info.sid == this.ikz_sys_pic_second[i].id) {
                        this.ikz_sys_pic_second[i].color = 'color:#409EFF';

                    }
                }

            },
            secondSelect(id) {
                //				for(var i = 0;i<this.ikz_sys_pic_second.length;i++){
                //					this.ikz_sys_pic_second[i].color = '';
                //				}
                //				this.ikz_sys_pic_second[index].color = 'color:#409EFF';
                this.ikz_sys_pic_info.limit = 18;
                this.ikz_sys_pic_info.page = 1;
                this.ikz_sys_pic_info.sid = id;
                this.ikz_sys_pic_return = [];
                this.ikzSysPicPictureLists();
            },
            //显示tab
            ikzSysPicPictypelist() {
                var data = {
                    change: this.ikz_sys_pic_info.change,
                    limit: this.ikz_sys_pic_info.limit,
                    page: this.ikz_sys_pic_info.page,
                    show_status: this.show_status
                }
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/storage/StoragePicturesType/allList', data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        if(res.data.data){
                            this.picstype = res.data.data;
                            this.picstype.unshift({
                                bname: '全部分组',
                                id: '0'
                            });
                        }else{
                            this.picstype = [];
                            this.picstype.unshift({
                                bname: '全部分组',
                                id: '0'
                            });
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
               
            },
            //获取图片详细信息和系统图库二级导航内容
            ikzSysPicPictureLists() {
                var data = {
                    change: this.ikz_sys_pic_info.change,
                    tid: this.ikz_sys_pic_info.id,
                    limit: this.ikz_sys_pic_info.limit,
                    page: this.ikz_sys_pic_info.page,
                    sid: this.ikz_sys_pic_info.sid
                }
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/storage/StoragePictures/index', data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                       if(this.ikz_sys_pic_info.page == 1 && res.data.count == 0) {
                        this.null_status = true;
                       } else {
                        this.null_status = false;
                       }
                       this.ikz_sys_pic_count = Number(res.data.count);
                       this.ikz_sys_pic_data = res.data.data;
                       if(this.ikz_sys_pic_info.change == 'sys' && this.ikz_sys_pic_info.id != 0) {
                        this.ikz_sys_pic_second = res.data.second_info;
                        this.ikz_sys_pic_second.unshift({
                            bname: '全部',
                            id: '0',
                        });
                        this.secondColor();
                       }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
                // ikz.post('/home/Units/Admin/System/piclist', data, (res) => {
                    
                // })
            },
            //点击下一页
            handleCurrentChange(e) {
                this.ikz_sys_pic_info.page = Number(e);
                this.ikzSysPicPictureLists();
            },

            //获取左侧栏一级分类id
            ikzSysPicTypeid(tab) {
                console.log(tab.index);
                if(tab.index == this.picstype.length) {
                    this.dialogFormVisible = true;
                } else {
                    this.ikz_sys_pic_info.id = this.picstype[tab.index].id;
                    this.ikz_sys_pic_info.page = 1;
                    this.ikz_sys_pic_info.sid = "0";
                    this.ikzSysPicPictureLists();
                    this.ikz_sys_pic_ajax_tid = this.picstype[tab.index].id;
                    this.ikz_sys_pic_return = [];
                }
            },
            //选中图片
            ikzSysPicGetImg(url, id, index) {

                var imgstatus = this.ikzSysPicIndexof(url); //判断选择是否重复
                var ikz_sys_pic_temp = '';
                if(this.ikz_sys_pic_receive.num == '-1') {
                    if(imgstatus == "-1") {
                        ikz_sys_pic_temp = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temp.status = true;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temp)
                        this.ikz_sys_pic_return.push(url);
                    } else {
                        ikz_sys_pic_temp = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temp.status = false;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temp)
                        this.ikz_sys_pic_return.splice(imgstatus, 1);
                    }
                } else if(this.ikz_sys_pic_receive.num == '1') {
                    if(imgstatus == "-1") {
                        ikz_sys_pic_temp = this.ikz_sys_pic_data;
                        for(var i = 0; i < ikz_sys_pic_temp.length; i++) {
                            ikz_sys_pic_temp[i].status = false;
                        }

                        this.ikz_sys_pic_data = ikz_sys_pic_temp;
                        var ikz_sys_pic_temps = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temps.status = true;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temps)

                        this.ikz_sys_pic_return[0] = url;
                    } else {
                        ikz_sys_pic_temp = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temp.status = false;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temp)
                        this.ikz_sys_pic_return.splice(imgstatus, 1);
                    }
                } else {
                    if(imgstatus == "-1") {
                        if(this.ikz_sys_pic_return.length >= this.ikz_sys_pic_receive.num) {
                            this.$message('最多选择' + this.ikz_sys_pic_receive.num + '张图片！');
                            return false;
                        }
                        ikz_sys_pic_temp = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temp.status = true;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temp)
                        this.ikz_sys_pic_return.push(url);
                    } else {
                        ikz_sys_pic_temp = this.ikz_sys_pic_data[index];
                        ikz_sys_pic_temp.status = false;
                        Vue.set(this.ikz_sys_pic_data, index, ikz_sys_pic_temp)
                        this.ikz_sys_pic_return.splice(imgstatus, 1);
                    }
                }
            },

            //判断是否有
            ikzSysPicIndexof(url) {
                for(var i = 0; i < this.ikz_sys_pic_return.length; i++) {
                    if(this.ikz_sys_pic_return[i] == url) {
                        return i;
                    }
                }
                return "-1";
            },
         
            //上传图片
            ikzSysPicPreviewImage(event) {
                
                    let file = event.target.files[0];
                    if (/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(event.target.value)) {
                        let MAXSIZE = 10 * 1024 * 1024;
                        let size = file.size;
                        if (size > MAXSIZE) {
                            event.target.value = "";
                            this.$notify.error({
                                title: "上传图片错误",
                                message: "上传图片不能超过10M",
                            });
                            return;
                        }
                        this.loading = true;
                        let reader = new FileReader();
                        let self = this;
                        reader.readAsDataURL(file);
                        let img = new Image();
                        reader.onload = function(e) {
                            img.src = this.result;
                            img.onload = function() {
                                let base = e.target.result;
                                let fileItem = file;
                                if (self.isCompress) {
                                    base = self.compress(img);
                                    fileItem = self.dataURItoBlob(base);
                                }
                                let formdata = new window.FormData();
                                formdata.append("file", fileItem);
                                formdata.append("tid", self.ikz_sys_pic_info.id);
                                axios({
                                        method: "POST",
                                        url: "/storage/StoragePictures/uploadImage",
                                        data: formdata,
                                        timeout: 1000000,
                                        headers: {
                                            "Content-Type": "multipart/form-data",
                                        },
                                    })
                                    .then(() => {
                                        self.ikz_sys_pic_info.page = 1;
                                        self.ikzSysPicPictureLists();
                                    })
                                    .catch((e) => {
                                        event.target.value = "";
                                        self.loading = false;
                                        this.$message.error(e.message);
                                    });
                            };
                        };
                    } else {
                        event.target.value = "";
                        this.$notify.error({
                            title: "上传图片错误",
                            message: "请上传gif|jpg|jpeg|png|GIF|JPG|PNG格式图片",
                        });
                    }
                // var img = imgFile.target.files;
                // var img_type = img[0].type.substring(img[0].type.indexOf('/')+1);//截取字符串
                // for(var i = 0; i < img.length; i++) {
                //     this.ikzSysPicImgAdd(img[i], 3,img_type);
                // }
                // return false;
            },
            base64ToBlob({
                b64data = '',
                contentType = '',
                sliceSize = 512
            } = {}) {
                return new Promise((resolve) => {
                    // 使用 atob() 方法将数据解码
                    let byteCharacters = atob(b64data);
                    let byteArrays = [];
                    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        let slice = byteCharacters.slice(offset, offset + sliceSize);
                        let byteNumbers = [];
                        for(let i = 0; i < slice.length; i++) {
                            byteNumbers.push(slice.charCodeAt(i));
                        }
                        // 8 位无符号整数值的类型化数组。内容将初始化为 0。
                        // 如果无法分配请求数目的字节，则将引发异常。
                        byteArrays.push(new Uint8Array(byteNumbers));
                    }
                    let result = new Blob(byteArrays, {
                        type: contentType
                    })
                    result = Object.assign(result, {
                        // jartto: 这里一定要处理一下 URL.createObjectURL
                        preview: URL.createObjectURL(result),
                        name: '图片示例.png'
                    });
                    resolve(result)
                })
            },
            
            dataURLtoFile(dataurl, filename) { //将base64转换为文件
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while(n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {
                    type: mime
                });
            },
            //上传图片
            // ikzSysPicImgAdd(base64Codes, id,img_type) {
                
            //     var that = this;
            //     let postData = new FormData(); // FormData 对象

            //     var files = base64Codes;
            //     if(id == 2) {
            //         files = this.convertBase64UrlToBlob(base64Codes, "file_" + Date.parse(new Date()) + "."+img_type);

            //         if(files.size > 500000 && img_type!='gif') {
            //             var obj = {
            //                 width: 500
            //             }
            //             this.ikzSysPicPhotoCompress(img[i], obj, (base64Res) => {
            //                 this.ikzSysPicImgAdd(base64Res, 2,img_type);
            //             });
            //             return false;
            //         }
            //     } else {
            //         files = base64Codes;
            //     }
            //     postData.append("file", files, "file_" + Date.parse(new Date()) + "."+img_type); // 文件对象
            //     postData.append('tid', this.ikz_sys_pic_ajax_tid);
            //     postData.append('ser_path', this.pic_path.ser_path);
            //     // var path = this.pic_path.ser_url;
            //     if(files.type.indexOf('video')!= -1){
            //         postData.append('pic_type', 3);
            //     }else{
            //         postData.append('pic_type', 2);
            //     }
            //     var path = '/home/Units/Admin/System/addPic';
            //     ikz.file(path, postData, (res) => {
            //         if(res.data.status == 'success') {
            //             this.ikzSysPicAdd(res.data);
            //         } else {
            //             if(res.data.info) {
            //                 that.$message(res.data.info);
            //             } else {
            //                 that.$message('上传失败，服务器繁忙，请稍后再试！');
            //             }
            //         }
            //     })
            // },
            //保存上传的图片
            ikzSysPicAdd(data){
                var temp_data = {
                    tid: this.ikz_sys_pic_ajax_tid,
                    url: data.info,
                    pic_type:data.pic_type
                }
                this.$http.post('/storage/StoragePictures/index', temp_data).then(res => {
                    if (res.data.code === 0) {
                       if(this.ikz_sys_pic_info.page == 1 && res.data.count == 0) {
                        this.null_status = true;
                       } else {
                        this.null_status = false;
                       }
                       this.ikz_sys_pic_count = Number(res.data.count);
                       this.ikz_sys_pic_data = res.data.data;
                       if(this.ikz_sys_pic_info.change == 'sys' && this.ikz_sys_pic_info.id != 0) {
                        this.ikz_sys_pic_second = res.data.second_info;
                        this.ikz_sys_pic_second.unshift({
                            bname: '全部',
                            id: '0',
                        });
                        this.secondColor();
                       }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
// 				ikz.post('/home/Units/Admin/System/uploadpic', temp_data, (res) => {
// 					if(res.data.status == 'success') {
// 						this.$message('图片上传成功');
// 						this.ikz_sys_pic_info.page = 1;
// 						this.ikzSysPicPictureLists();
// 						this.img.url = '';
// //						layer.close(ikz_sys_pic_load);
// 						this.visible = false;
// 					} else {
// 						this.form.bname = '';
// 						this.$message('添加图片失败');
// 					}
// 				})
            },
            /*	
                    三个参数
                    file：一个是文件(类型是图片格式)，
                    w：一个是文件压缩的后宽度，宽度越小，字节越小
                    objDiv：一个是容器或者回调函数
                    ikzSysPicPhotoCompress()
                     */
            //将图片转成base64
            ikzSysPicPhotoCompress(file, obj, objDiv) {
                var ready = new FileReader();
                /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
                ready.readAsDataURL(file);
                var that = this;
                ready.onload = function() {
                    var re = this.result;
                    that.ikzSysPicCanvasDataURL(re, obj, objDiv)
                }
            },
            //压缩图片
            ikzSysPicCanvasDataURL(path, obj, callback) {
                var img = new Image();
                img.src = path;
                img.onload = function() {
                    var that = this;
                    // 默认按比例压缩
                    var w = that.width,
                        h = that.height,
                        scale = w / h;
                    w = obj.width || w;
                    h = obj.height || (w / scale);

                    if(h > 1500) {
                        h = 1500;
                        w = scale * h;
                    }

                    var quality = 0.95; // 默认图片质量为0.95
                    //生成canvas
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    // 创建属性节点
                    var anw = document.createAttribute("width");
                    anw.nodeValue = w;
                    var anh = document.createAttribute("height");
                    anh.nodeValue = h;
                    canvas.setAttributeNode(anw);
                    canvas.setAttributeNode(anh);
                    ctx.drawImage(that, 0, 0, w, h);
                    // 图像质量
                    if(obj.quality && obj.quality <= 1 && obj.quality > 0) {
                        quality = obj.quality;
                    }
                    // quality值越小，所绘制出的图像越模糊
                    var base64 = canvas.toDataURL('image/jpeg', quality);
                    // 回调函数返回base64的值
                    callback(base64);
                }
            },
            /**
             * 将以base64的图片url数据转换为Blob
             * @param urlData
             *            用url方式表示的base64图片数据
             */
            //将base64 转成 blob
            convertBase64UrlToBlob(urlData) {
                var arr = urlData.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while(n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            // convertBase64UrlToBlob(urlData) {
            // 	const bytes = window.atob(urlData.split(',')[1]); // 去掉url的头，并转换为byte
            // 	// 处理异常,将ascii码小于0的转换为大于0 
            // 	const ab = new ArrayBuffer(bytes.length);
            // 	const ia = new Uint8Array(ab);
            // 	for(let i = 0; i < bytes.length; i++) {
            // 		ia[i] = bytes.charCodeAt(i);
            // 	}
            // 	return new Blob([ab], {
            // 		type: 'image/png'
            // 	});
            // },
            //提交
            ikzSysPicSubmit() {
                //判断是否选择图片
                if(this.ikz_sys_pic_return.length == 0) {
                    this.$message('请选择图片后再提交');
                    return false;
                } else {
                    var res_info_data = {};
                    //判断是否为无限张
                    if(this.ikz_sys_pic_receive.num == '-1') {
                        res_info_data = {
                            former: this.ikz_sys_pic_receive.former,
                            data: this.ikz_sys_pic_return
                        }
                        this.$emit('picReturn', res_info_data);
                        //						ikz_sys_pic_receive.success(res_info_data);
                        this.ikz_sys_pic_return = [];
                        this.ikz_sys_pic_status = 3;
                        this.ikz_sys_pic_key = 3;
                    } else if(this.ikz_sys_pic_receive.num > '0') {
                        //判断是否严格限制数量
                        if(this.ikz_sys_pic_receive.strict) {
                            if(this.ikz_sys_pic_receive.num == this.ikz_sys_pic_return.length) {
                                res_info_data = {
                                    former: this.ikz_sys_pic_receive.former,
                                    data: this.ikz_sys_pic_return
                                }
                                this.$emit('picReturn', res_info_data);
                                this.ikz_sys_pic_return = [];
                                this.ikz_sys_pic_status = 3;
                                this.ikz_sys_pic_key = 3;
                            } else {
                                this.$message('请选择' + this.ikz_sys_pic_receive.num + '图片后在提交！');
                                return false;
                            }
                        } else {
                            res_info_data = {
                                former: this.ikz_sys_pic_receive.former,
                                data: this.ikz_sys_pic_return
                            }
                            this.$emit('picReturn', res_info_data);
                            this.ikz_sys_pic_return = [];
                            this.ikz_sys_pic_status = 3;
                            this.ikz_sys_pic_key = 3;
                        }
                    }
                    this.dialogVisible.status = false;
                }
            },
            //弹出添加分类
            ikzSysPicOpenadd() {
                var that = this;
                if(this.form.bname) {
                    var data = {
                        bname: this.form.bname,
                    }
                    this.$http.post('/storage/StoragePicturesType/edit', data).then(res => {
                        if(res.data.code == '0') {
                            that.$message('添加分类成功');
                            this.activeName = this.oldactiveName;
                            this.dialogFormVisible = false;
                            this.ikzSysPicPictypelist();
                        } else {
                            this.form.bname = '';
                            that.$message('添加分类失败');
                        }
                    })
                } else {
                    this.$message.error('请填写分类名称，再点击确定');
                }
            },
            ikzSysPicOpenClose() {
                this.form.bname = '';
                this.activeName = this.oldactiveName;
                this.dialogFormVisible = false;
            },
            /** 图库选择器封装结束 **/

            changeImage: function(e) {
                let file = e.target.files[0];
                if(file) {
                    this.file = file
                    let reader = new FileReader()
                    let that = this
                    reader.readAsDataURL(file)
                    reader.οnlοad = function() {
                        // 这里的this 指向reader
                        that.avatar = this.result
                    }
                }
            },
            handleClose(){
                
            },
            upload: function() {
                let files = this.$refs.avatarInput.files
                let fileData = {}
                if(files instanceof Array) {
                    fileData = files[0]
                } else {
                    fileData = this.file
                }
                let data = new FormData()
                data.append('multfile', fileData)
                data.append('operaType', this.uploadType)
                this.$store.dispatch('UPLOAD_HEAD', data)
                    .then(res => {
                        this.file = '';
                        let data = res.data.data;
                        this.$emit("upload", data);
                        this.$message({
                            type: "success",
                            message: "上传成功！"
                        })
                    }).catch(err => {
                        if(err.data.msg) {
                            this.$message({
                                type: "error",
                                message: err.data.msg
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: "上传失败"
                            })
                        }
                    })
            }
        },
        mounted() {
            //					let postData= new URLSearchParams();
            //					postData.append('change',  'per');
            //					postData.append('id',  0);
            //					postData.append('limit',  18);
            //					postData.append('page',  1);
            //					postData.append('sid',  0);
            //					this.$axios.post('/Ceshi/pictypeList&param='+ this.$utils.getUrlKey("param"), postData)
            //						.then(function(response) {
            //						})
        },
        computed: {
            //			dialogVisible() {
            //				return this.infoData;
            //			},
        }
    }
</script>
<style scoped>
    .ikz-add-type {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 1010;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .ikz-add-box {
        width: 400px;
        height: 210px;
        background: #fff;
        border-radius: 5px;
    }
    
    .ikz-add-title {
        text-align: center;
        line-height: 50px;
    }
    
    .ikz-add-form {
        margin-top: 20px;
    }
    
    .ikz-add-footer {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    
    .ikz-bg-filter {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 99999;
    }
    
    .ikz-sys-pic-section {
        width: 700px;
        height: 442px;
        position: fixed;
        margin: auto;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 300;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 2px;
    }
    
    .ikz-top-menu {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
    }
    
    .ikz-top-menu-left {
        /*#409EFF*/
        border-left: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        border-right: 0px;
        background: #fff;
        padding: 7px;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }
    
    .ikz-top-menu-right {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        border-left: 0px;
        background: #fff;
        padding: 7px;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }
    
    .ikz-pic-right-image {
        width: 86%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        margin: 15px auto 0px;
    }
    
    .ikz-pic-list-right-tips {
        margin: 0px 50px;
    }
    
    .ikz-pic-list-left-tabs {
        height: 100%;
    }
    
    .ikz-pic-list-right {
        width: 86%;
        position: relative;
        height: 388px;
    }
    
    .ikz-pic-list-left {
        height: 388px;
        width: 18%
    }
    
    .ikz-pic-list {
        display: flex;
    }
    
    .ikz-pic-file-input {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 0px;
    }
    
    .ikz-pic-updata {
        position: absolute;
        right: 20px;
        top: 0px;
    }
    
    .ikz-pic-group {
        /*margin-top: 10px;*/
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #eee;
    }
    
    .ikz-pic-box {
        height: 442px;
        position: relative;
    }
    
    .ikz-sys-pic-page {
        margin: 0;
        height: 100%;
        text-align: center;
    }
    
    .ikz-sys-pic-list {
        width: 20%;
    }
    
    .ikz-sys-pic-tab {
        text-align: center;
    }
    
    .ikz-sys-pic-pics {
        display: flex;
        flex-wrap: wrap;
        font-size: 15px;
        margin: 25px 4%;
    }
    
    .ikz-sys-pic-picsbod {
        width: 70px;
        height: 70px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #ddd;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .ikz-sys-pic-picssdiv {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        font-size: 50px;
        text-align: center;
        color: rgb(255, 255, 255);
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }
    
    .ikz-sys-pic-picsselt {
        z-index: 99999;
    }
    
    .ikz-sys-pic-picspic {
        width: 68px;
        max-height: 68px;
    }
    
    .ikz-sys-pic-pages {
        text-align: center;
    }
    
    .ikz-sys-pic-alert {
        position: fixed;
        top: 30%;
        left: 0px;
        right: 0px;
        margin: auto;
        z-index: 999;
        background-color: #f7f7f7;
        width: 500px;
        height: 180px;
        padding-top: 40px;
        border-radius: 5px;
        text-align: center;
    }
    
    .ikz-sys-pic-dl {
        width: 100%;
        height: 400px;
        overflow-y: scroll;
    }
    
    .ikz-sys-pic-bottom {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 10px;
    }
    
    .ikz-sys-pic-btn {
        width: 100%;
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    
    .ikz-sys-pic-prompt {
        display: block;
        text-align: center;
        width: 100%;
    }
    
    .ikz-sys-pic-tids {
        margin-bottom: 0px;
        margin-top: 8px;
        padding: 0px;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        text-decoration: none;
        -webkit-transition: color .2s cubic-bezier(.645, .045, .355, 1);
        transition: color .2s cubic-bezier(.645, .045, .355, 1);
        color: #303133;
        margin-left: 8px;
    }
    
    .ikz-null {
        width: 86%;
        height: 100px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    
    .ikz-null-img {
        width: 50px;
        height: 50px;
    }
    
    .ikz-null-title {
        width: 100%;
        text-align: center;
        color: #777777;
        font-size: 14px;
        margin-top: 10px;
    }
</style>